module.exports = __webpack_public_path__ + "static/img/VENICE-MAJESTIC-WALNUT.0705378.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VENICE-MAJESTIC-WALNUT.png
// module id = hHi9
// module chunks = 0